module.exports = new __parcel__URL__("closed-hihat_7.769c6d06.mp3").toString();